import React from 'react';

/**
 * ROO-200: catch render/chunk-load errors so a failed lazy import (common right
 * after a deploy, when old chunk URLs 404) shows a recoverable message instead
 * of a white screen. A reload pulls the new chunk manifest.
 */
interface State { hasError: boolean; isChunkError: boolean; }

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false, isChunkError: false };

  static getDerivedStateFromError(error: unknown): State {
    const msg = error instanceof Error ? error.message : String(error);
    const isChunkError = /chunk|dynamically imported module|Loading CSS chunk/i.test(msg);
    return { hasError: true, isChunkError };
  }

  componentDidCatch(error: unknown) {
    // eslint-disable-next-line no-console
    console.error('Admin ErrorBoundary caught:', error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ padding: 40, textAlign: 'center', fontFamily: 'sans-serif' }}>
        <h2>Something went wrong</h2>
        <p style={{ color: '#666' }}>
          {this.state.isChunkError
            ? 'A new version was just deployed. Reload to get the latest.'
            : 'An unexpected error occurred while loading this page.'}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{ padding: '8px 20px', fontSize: 14, cursor: 'pointer', borderRadius: 6 }}
        >
          Reload
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
